import { Injectable } from '@angular/core';
import { FuseConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';
import { MatDialogRef, MatDialog, NativeDateAdapter } from '@angular/material';
import { Router } from '@angular/router';

@Injectable()
export class AppService {
    translationData: any = [];
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    timeoutShown: boolean = false;
    invalidForm : boolean = true;
    deliveryStatus : Number = 0;

    constructor(public dialog: MatDialog,
        public router: Router) {
    }
    setFormValid(status){
        this.invalidForm = status;
    }    
    showLoading() {
        document.getElementsByClassName('loadingBackdrop')[0]["style"].display = "block";
    }
    hideLoading() {
        document.getElementsByClassName('loadingBackdrop')[0]["style"].display = "none";
    }
    checkSession() {
        if (sessionStorage.getItem('authToken') == null) {
            this.router.navigateByUrl('/login')
        }
    }
    showDialogue(title, message, isConfirm = false) {
        this.hideLoading();
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });
        if (typeof message != 'string') {
            message = JSON.parse(sessionStorage.getItem('pageData'))['msgCommonError'];
        }
        this.confirmDialogRef.componentInstance.message = message;
        this.confirmDialogRef.componentInstance.confirm = isConfirm;
        this.confirmDialogRef.componentInstance.title = title;
        return this.confirmDialogRef;
    }
    timeOut() {
        if(sessionStorage.getItem('timeoutShown') == '0'){
            sessionStorage.setItem('timeoutShown', '1');
            alert('Your session has been timed out, you are redirected to login page.');
            sessionStorage.clear();
        }
    }
    onFormValuesChanged(formGroup, formGroupErrors) {
        for (const field in formGroupErrors) {
            if (!formGroupErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            formGroupErrors[field] = {};

            // Get the control
            const control = formGroup.get(field);

            if (control && control.dirty && !control.valid) {
                formGroupErrors[field] = control.errors;
            }
        }
        
        return formGroupErrors;
    }
    onlyPositiveNumber(e){
        
        const allowedChar = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            navigator.language.indexOf('en') > -1 ? '.' : ',',
          ];
          if (
            (e.key === '.' || e.key === ',') &&
            e.currentTarget.value.toString().indexOf('.') > -1
          ) {
            return false;
          }
      
          if (e.currentTarget.value.toString() === '0' && e.key !== '.' && e.key !== ',') {
            if (e.currentTarget.getAttribute('Data') !== '.') {
              e.currentTarget.value = undefined;
            }
          } else if (
            e.currentTarget.toString() === '0' &&
            (e.key === '.' || e.key === ',')
          ) {
            e.currentTarget.setAttribute('Data', '.');
          } else {
            e.currentTarget.setAttribute('Data', '');
          }
          if (e.currentTarget.value.indexOf('.') > -1) {
            if (
              typeof e.currentTarget.max !== 'undefined' &&
              e.currentTarget.max.indexOf('.') > -1 &&
              e.currentTarget.value.split('.').length > 1
            ) {
              if (
                window.getSelection().type !== 'Range' &&
                e.currentTarget.max.split('.')[1].length <=
                e.currentTarget.value.split('.')[1].length
              ) {
                return false;
              }
            }
          }
          if (
            (e.currentTarget.value === undefined || e.currentTarget.value === '') &&
            (e.key === '.' || e.key === ',')
          ) {
            return false;
          }
          return allowedChar.indexOf(e.key.toString()) > -1 ? true : false;
    }
    onlyNumber(e){
        let allowedChar = ["-","0","1","2","3","4","5","6","7","8","9"
        ,navigator.language.indexOf("en") > -1 ? "." :","]
        if((e.key == "." || e.key == ",") && e.currentTarget.value.toString().indexOf(".") > -1){
            return false;
        }
        if(e.currentTarget.value == 0 && (e.key != "." && e.key != ",")){
            if(e.currentTarget.getAttribute("Data") != "."){
                e.currentTarget.value = undefined;
            }            
        }
        else if(e.currentTarget.value == 0 && (e.key == "." || e.key == ",")){
            e.currentTarget.setAttribute("Data",".");
        }
        else{
            e.currentTarget.setAttribute("Data","");
        }
        if(e.currentTarget.value.indexOf(".") > -1){
            if(typeof e.currentTarget.max != 'undefined' 
            && e.currentTarget.max.indexOf(".") > -1 
            && e.currentTarget.value.split(".").length > 1){
                if(window.getSelection().type != "Range" && e.currentTarget.max.split(".")[1].length <= e.currentTarget.value.split(".")[1].length){
                    return false;
                }
            }
        }
        if((e.currentTarget.value == undefined || e.currentTarget.value == "") && (e.key == "." || e.key == ",")){
            return false;
        }
        return allowedChar.indexOf(e.key.toString()) > -1  ? true : false;
    }
    onKeydown(e){
        
        var KeyID = e.keyCode;
        switch(KeyID)
        {
           case 8:
           e.currentTarget.setAttribute("Data","");
           break; 
           case 46:
           e.currentTarget.setAttribute("Data","");
           break;
        }
    }

    checkRange(element){
        if (element.value.length > element.maxLength) element.value = element.value.slice(0, element.maxLength);
    }
    mapDataTableProp(dataTableProp,data){
        dataTableProp.isEdit = data.isEdit;
        dataTableProp.isView = data.isView;
        dataTableProp.isDelete = data.isDelete;
        dataTableProp.isAdd = data.isAdd;
        dataTableProp.iscustom = data.isCustom;
        dataTableProp.displayedColumns = eval(data.displayedColumns);
        return dataTableProp;
    }

    mapDataTablePropWithIndicators(dataTableProp, data, indicatorColumns){
        dataTableProp.isEdit = data.isEdit;
        dataTableProp.isView = data.isView;
        dataTableProp.isDelete = data.isDelete;
        dataTableProp.isAdd = data.isAdd;
        dataTableProp.iscustom = data.isCustom;
        dataTableProp.indicators = indicatorColumns;
        dataTableProp.displayedColumns = eval(data.displayedColumns);
        dataTableProp.isViewDetail = data.isViewDetail;
        return dataTableProp;
    }

    uniqueBy(arr, fn) {
        var unique = {};
        var distinct = [];
        arr.forEach(function (x) {
          var key = fn(x);
          if (!unique[key.Id]) {
            distinct.push(key);
            unique[key.Id] = true;
          }
        });
        return distinct;
      }

     isNegative(val){
          return Number(val) < 0 ? 'warn' : 'primary';
     }
      ISO8601_week_no(dt) 
      {
          if(typeof dt == 'undefined' || dt == null){
            return;
        }
        if(typeof dt == 'string'){
            dt =  dt.substring(0, 10);
            var from = dt.split("-");
            if(from[0].length == 2)
                dt = new Date(from[2], from[1] - 1, from[0]);
            else
                dt = new Date(from[0], from[1] - 1, from[2]);
        }
         var tdt : any = new Date(dt.valueOf());
         var dayn = (dt.getDay() + 6) % 7;
         tdt.setDate(tdt.getDate() - dayn + 3);
         var firstThursday = tdt.valueOf();
         tdt.setMonth(0, 1);
         if (tdt.getDay() !== 4) 
           {
          tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
            }
         return 1 + Math.ceil((firstThursday - tdt) / 604800000);
    }
    JSONDate(d : Date) {
        try{
            return new Date( d.getTime() - ( d.getTimezoneOffset() * 60000))
        }
        catch(ex){
            return d;
        }
    }
      
}

export class AppDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek(): number {
      return 1;
    }

    parse(value: any): Date | null {
     if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
       const str = value.split('/');
       const year = Number(str[2]);
       const month = Number(str[1]) - 1;
       const date = Number(str[0]);
       return new Date(year, month, date);
     }
     const timestamp = typeof value === 'number' ? value : Date.parse(value);
     return isNaN(timestamp) ? null : new Date(timestamp);
   }
 
    format(date: Date, displayFormat: Object): string {
        
        if (displayFormat == "input") {
            
            //date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            return this._to2digit(day) + '-' + this._to2digit(month) + '-' + year;
        } else {
            return date.toDateString();
        }
    }
 
    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    } 
 }
 
 export const APP_DATE_FORMATS =
 {
    parse: {
        dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: { month: 'short', year: 'numeric', day: 'numeric' },
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'},
    }
 }






// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/app.service.ts